// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1805 ? "25f4ac2a" : chunkId) + "." + {"281":"e76e9cc93875a9ec","1805":"30dc3b0963889998","5041":"850ba15c6955dce4","5880":"f0ef0805c40fa8a7","6239":"d76230fc23d68c2f","8951":"74eae6f70589d4aa"}[chunkId] + ".js";
};